import { http } from './config'

export default {

  getAllRoles: () => {
    return http.get('roles')
  },

  getRoles: () => {
    return http.get('roles?quantity=200')
  },

  getFilteredRoles: (params) => {
    return http.get('roles', {params})
  },

  getRoleById: (roleID) => {
    return http.get('roles/' + roleID)
  },

  createRole: (roleParams) => {
    return http.post('roles', {
      name: roleParams.name
    }
  )},

  updateRole: (roleParams) => {
    return http.put('roles/' + roleParams.id, {
      name: roleParams.name
    }
  )},

  deleteRole: (roleID) => {
    return http.delete('roles/' + roleID)
  }
}
